module.exports = __webpack_public_path__ + "img/q30-5.2449fb6e.jpg";